import { useDetailOverlay } from "@/lib/DetailOverlayContext";
import { useLang } from "@/lib/i18n";

// One service the guide has opened a page for but no business has claimed yet.
// The tile says what the service is and asks whoever runs one to step forward;
// tapping it opens that service's page, where the claim form lives.
const GLYPHS = {
  Barbershops: "✂️",
  "Hair Salons & Stylists": "💇",
  "Nail Salons": "💅",
  "Spas & Massage": "💆",
  "Tattoo & Piercing Studios": "🎨",
  "Fitness & Gyms": "🏋️",
  "Yoga & Pilates Studios": "🧘",
  "Dance Studios": "💃",
  "Tailors & Alterations": "🧵",
  "Repair & Handyman Services": "🔧",
  "Photography & Videography": "📸",
  "Professional Services": "💼",
  "Legal & Notary Services": "⚖️",
  "Printing & Shipping": "🖨️",
  "Coworking Spaces": "💻",
  "Car Rentals & Transportation": "🚗",
  "Car Wash & Detailing": "🚿",
  "Tour Operators": "🧭",
  "Laundry & Dry Cleaning": "🧺",
  "Cleaning Services": "🧼",
  "Event & Party Services": "🎉",
  "Pet Services": "🐾",
  "Wellness & Alternative Therapy": "🌿",
  "Health & Medical Clinics": "🩺",
  "Moving & Storage": "📦",
  "Luggage Storage": "🧳",
};

export default function ServiceTypeTile({ listing }) {
  const { openListing } = useDetailOverlay();
  const { t } = useLang();

  return (
    <button type="button" onClick={() => openListing(listing.id)} className="group w-full text-left">
      <div className="relative aspect-[4/3] rounded-[18px] bg-[#EDEBE6] grid place-items-center overflow-hidden transition-colors group-hover:bg-[#deded9]">
        <span className="text-[30px] leading-none" aria-hidden="true">
          {GLYPHS[listing.subcategory] || "🛠️"}
        </span>
        <span className="absolute left-3 bottom-3 rounded-full bg-white/90 px-2.5 py-1 font-mono text-[9.5px] tracking-[0.16em] uppercase font-bold text-[#171717]">
          {t("detail.comingSoon")}
        </span>
      </div>
      <h3 className="mt-2.5 text-[15px] sm:text-[16px] font-extrabold tracking-[-0.02em] text-[#171717]">
        {listing.name}
      </h3>
      <p className="mt-0.5 text-[12px] font-bold text-[#6d6d6a]">{t("services.claim")}</p>
    </button>
  );
}